import React from 'react';
import './PickSeatManually.scss';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';

const PickSeatManually: React.SFC<{}> = ({ children }) => (
  <WrapperBox style='pick-seat-manually'>
    { children }
  </WrapperBox>
);

export default PickSeatManually;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/PickSeatManually.tsx